import React, { useContext, useEffect, useState } from 'react'
import Header from '../../Components/Header'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import MapContext from '../../Components/MapContext';
import toast from 'react-simple-toasts';
import axios from 'axios';
import BaseUrl from '../../BaseUrl';
import Swal from 'sweetalert2';
import "react-country-state-city/dist/react-country-state-city.css";

const EditQuotation = () => {


    const navigate = useNavigate()



    const location = useLocation()
    const { id } = location.state




    const [companyName, setCompanyName] = useState(null)
    const [companyEmail, setCompanyEmail] = useState(null)
    const [companyPhone, setCompanyPhone] = useState(null)
    const [companyAddress, setCompanyAddress] = useState(null)
    const [custName, setCustName] = useState(null)
    const [custEmail, setCustEmail] = useState(null)
    const [custPhone, setCustPhone] = useState(null)
    const [custAddress, setCustAddress] = useState(null)
    const [subTotal, setSubTotal] = useState(null)
    const [status, setStatus] = useState(null)
    const [dueDate, setDueDate] = useState(null)
    const [total, setTotal] = useState(null)
    const [setupFee, setSetupFee] = useState(null)
    const [prodDesc, setProdDesc] = useState(null)
    const [prodQuant, setProdQuant] = useState(null)
    const [prodPrice, setProdPrice] = useState(null)
    const [product, setProduct] = useState([])



    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }


    const query = useQuery();
    const page = query.get('page');
    const search = query.get('search');


    const [data, setData] = useState([])
    const [plan_id, setPlan_id] = useState(null)
    const [plan, setPlan] = useState(null)
    const [mysearch, setSearch] = useState('')




    useEffect(() => {
        try {

            axios.get(`${BaseUrl.baseUrl}/showPlans?page=${page ? page : 1}&search=${search ? search : ''}`).then(res => {
                if (res.data.status === 'ok') {

                    console.log(res.data);
                    setData(res.data?.plans)
                }
                else if (res.data.status === 'fail') {
                    toast('🚩' + res.data.message)
                }

            }).catch(err => {
                toast('🚨' + err.message)
            })


        } catch (err) {
            toast('🚨 Something went wrong!')
        }

    }, [plan])





    const [quotData, setQuotData] = useState({})


    useEffect(() => {
        try {

            axios.get(`${BaseUrl.baseUrl}/quotation/get/${id}`).then(res => {
                if (res.data.status === 'ok') {
                    setQuotData(res.data.data)
                    setCompanyName(res.data.data.companyName)
                    setCompanyEmail(res.data.data.companyEmail)
                    setCompanyPhone(res.data.data.companyPhone)
                    setCompanyAddress(res.data.data.companyAddress)
                    setCustName(res.data.data.custName)
                    setCustEmail(res.data.data.custEmail)
                    setCustPhone(res.data.data.custPhone)
                    setCustAddress(res.data.data.custAddress)
                    setSetupFee(res.data.data.setupFee)
                    setPlan_id(res.data.data.plan_id)
                    setStatus(res.data.data.status)
                    setDueDate(res.data.data.dueDate)
                    setProduct(res.data.data.product)
                    axios.get(`${BaseUrl.baseUrl}/plan/${res.data.data?.plan_id}`)
                        .then((res) => {
                            console.log(plan,'mmmmmmmmmmmmmmmmmmmm');
                            
                            if (res.data.status === 'ok') {
                                setPlan(res.data.plans);
                            } else {
                                toast('🚩' + res.data.message);
                            }
                        })
                        .catch((err) => toast('🚨' + err.message));
                }
                else if (res.data.status === 'fail') {
                    toast('🚩' + res.data.message)
                }

            }).catch(err => {
                toast('🚨' + err.message)
            })


        } catch (err) {
            toast('🚨 Something went wrong!')
        }

    }, [])



    const sendNewClientTemplate = async (userData, data) => {

        try {

            const setupFee = getSetupFee(userData?.features);

            const formdata = {
                "token": 'S7qFHAfW5XwIeYgKnYs7uz26Xpm4N7SvA7vrdvD4093914b5',
                "phone": data?.custPhone || data?.companyPhone,
                // phone: data?.phone,
                "template_name": 'quotation_made',
                "template_language": 'en', "components": [{
                    "type": "body", "parameters": [{ "type": "text", "text": data?.companyName }, { "type": "text", "text": userData?.name }, { "type": "text", "text": parseFloat(setupFee).toFixed(2) }, { "type": "text", "text": "0.00" }, { "type": "text", "text": (parseFloat(userData?.price) + parseFloat(setupFee || 0)).toFixed(2) }
                    ]
                }]
            }

            await axios.post('https://apps.oncloudapi.com/api/wpbox/sendtemplatemessage', formdata)
                .then((res) => {

                    if (res.data.status === 'success') {
                        navigate(-1)
                    }

                })
                .catch((error) => {
                    console.error(error)
                });


        } catch (err) {
            console.error(err)
        }
    }


    const submit = () => {
        if (!companyName) {
            toast('🚨 Must enter company name!')
        }
        else if (!companyEmail) {
            toast('🚨 Must enter company email!')
        }
        else {

            try {
                const param = {
                    companyName: companyName,
                    companyEmail: companyEmail,
                    companyPhone: companyPhone,
                    companyAddress: companyAddress,
                    custName: custName,
                    custEmail: custEmail,
                    custPhone: custPhone,
                    custAddress: custAddress,
                    subTotal: (plan?.price),
                    total: (parseInt(plan?.price) + parseInt(setupFee)),
                    setupFee: setupFee,
                    dueDate: dueDate,
                    status: status,
                    plan_id
                }


                axios.put(`${BaseUrl.baseUrl}/quotation/update/${id}`, param).then(res => {
                    if (res.data.status === 'ok') {
                        toast('🎉 Updated Successfully!')

                        sendNewClientTemplate(plan, param)

                    }
                    else if (res.data.status === 'fail') {
                        toast('🚩' + res.data.message)
                    }

                }).catch(err => {
                    toast('🚨' + err.message)
                })


            } catch (err) {
                toast('🚨 Something went wrong!')
            }

        }

    }

    const getSetupFee = (input) => {
        const match = input?.match(/Setup Fee\s*\$([\d.]+)/i);
        return match ? parseFloat(match[1]) : 0;
    };


    return (
        <div id="content" className="app-content ms-0">
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="#">Pages</Link>
                        </li>
                        <li className="breadcrumb-item active">Quotation</li>
                    </ul>
                    <h1 className="page-header mb-0">Quotation</h1>
                </div>
                <div className="ms-auto">
                    <Link to="/quotations" className="btn btn-theme fs-13px fw-semibold ">
                        Show Quotation
                    </Link>
                </div>
            </div>
            <div className="row gx-4">
                <div className="col-xl-12">
                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="response-message" />
                            <div >

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}
                                >
                                    <div className="mb-2 mt-3 col-5"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Company Name</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="companyName"
                                            placeholder="Company Name"
                                            className="form-control"
                                            defaultValue={companyName}
                                            onChange={(e) => { setCompanyName(e.target.value) }}
                                        />
                                    </div>


                                    <div className="mb-2 mt-3 col-5"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Company Email</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="companyName"
                                            placeholder="Company Email"
                                            className="form-control"
                                            defaultValue={companyEmail}
                                            onChange={(e) => { setCompanyEmail(e.target.value) }}
                                        />
                                    </div>

                                </div>


                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}
                                >
                                    <div className="mb-2 mt-3 col-5"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Company Phone</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="companyPhone"
                                            placeholder="Company Phone"
                                            className="form-control"
                                            defaultValue={companyPhone}
                                            onChange={(e) => { setCompanyPhone(e.target.value) }}
                                        />
                                    </div>


                                    <div className="mb-2 mt-3 col-5"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Company Address</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="companyAddress"
                                            placeholder="Company Address"
                                            className="form-control"
                                            defaultValue={companyAddress}
                                            onChange={(e) => { setCompanyAddress(e.target.value) }}
                                        />
                                    </div>

                                </div>




                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}
                                >
                                    <div className="mb-2 mt-3 col-5"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Customer Name</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="customerName"
                                            placeholder="Customer Name"
                                            className="form-control"
                                            defaultValue={custName}
                                            onChange={(e) => { setCustName(e.target.value) }}
                                        />
                                    </div>


                                    <div className="mb-2 mt-3 col-5"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Customer Email</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="customerEmail"
                                            placeholder="Customer Email"
                                            className="form-control"
                                            defaultValue={custEmail}
                                            onChange={(e) => { setCustEmail(e.target.value) }}
                                        />
                                    </div>

                                </div>


                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}
                                >
                                    <div className="mb-2 mt-3 col-5"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Customer Phone</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="customerPhone"
                                            placeholder="Customer Phone"
                                            className="form-control"
                                            defaultValue={custPhone}
                                            onChange={(e) => { setCustPhone(e.target.value) }}
                                        />
                                    </div>


                                    <div className="mb-2 mt-3 col-5"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Customer Address</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="customerAddress"
                                            placeholder="Customer Address"
                                            className="form-control"
                                            defaultValue={custAddress}
                                            onChange={(e) => { setCustAddress(e.target.value) }}
                                        />
                                    </div>

                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}
                                >

                                    <div className="mb-2 mt-3 col-5"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Due Date</label>
                                        <br />
                                        <input
                                            type="date"
                                            name="dueDate"
                                            placeholder="Due Date"
                                            className="form-control"
                                            defaultValue={dueDate}
                                            onChange={(e) => { setDueDate(e.target.value) }}
                                        />
                                    </div>


                                    <div className="mb-2 mt-3 col-5" style={{ marginRight: 20, marginLeft: 20 }}>
                                        <label htmlFor="">Select Invoice</label> <br />
                                        <select
                                            name="plan"
                                            className="form-select border rounded-3"
                                            required
                                            value={plan_id || ''}
                                            onChange={(e) => {
                                                const selectedId = e.target.value;
                                                const selectedPlan = data?.find((item) => item.id.toString() === selectedId);

                                                if (selectedPlan) {
                                                    setPlan(selectedPlan);
                                                    const setupFees = getSetupFee(selectedPlan.features);
                                                    setSetupFee(setupFees);
                                                    setPlan_id(selectedPlan.id);
                                                    console.log(setupFees, 'setupFees', selectedPlan);
                                                }
                                            }}
                                        >
                                            <option value="">Select the Invoice</option>

                                            {data?.length > 0 &&
                                                data.map((i) => (
                                                    <option key={i.id} value={i.id}>
                                                        {i.name}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>




                                </div>












                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}
                                >

                                    <div className="mb-2 mt-3 col-5"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Setup Fee Charges</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="tax"
                                            placeholder="Setup Fee Charges"
                                            className="form-control"
                                            disabled={true}
                                            defaultValue={setupFee}
                                            onChange={(e) => { setSetupFee(e.target.value) }}
                                        />
                                    </div>


                                    <div className="mb-2 mt-3 col-5" style={{ marginRight: 20, marginLeft: 20, }}>
                                        <label htmlFor="">Status</label> <br />
                                        <select name="plan" className="form-select  border rounded-3" id="" required="" onClick={(e) => { setStatus(e.target.value) }}>
                                            <option value="">Select the Quotation Status</option>

                                            <option value="Paid" selected={status === 'Paid' ? true : false}>Paid</option>
                                            <option value="Unpaid" selected={status === 'Unpaid' ? true : false}>Unpaid</option>

                                        </select>
                                    </div>



                                </div>



                                {/* 



                                <p className='mt-4 fw-bold'>Add Products</p>



                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}
                                >
                                    <div className="mb-2 mt-3 col-3"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Product Name</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="productDescription"
                                            placeholder="Product Name"
                                            className="form-control"
                                            required=""
                                            defaultValue={prodDesc}
                                            onChange={(e) => { setProdDesc(e.target.value) }}
                                        />
                                    </div>


                                    <div className="mb-2 mt-3 col-3"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Product Quantity</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="productQuantity"
                                            placeholder="Product Quantity"
                                            className="form-control"
                                            required=""
                                            defaultValue={prodQuant}
                                            onChange={(e) => { setProdQuant(e.target.value) }}
                                        />
                                    </div>

                                    <div className="mb-2 mt-3 col-3"
                                        style={{ marginLeft: 20, marginRight: 20 }} >
                                        <label htmlFor="">Product Price</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="productQuantity"
                                            placeholder="Product Price"
                                            className="form-control"
                                            required=""
                                            defaultValue={prodPrice}
                                            onChange={(e) => { setProdPrice(e.target.value) }}
                                        />
                                    </div>



                                </div>



                                <div className=" mb-5 mt-0" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <button type="submit" className="btn btn-theme" onClick={() => {
                                        console.log(prodDesc, prodQuant, prodPrice);
                                        if (prodDesc === null && prodPrice === null && prodQuant === null) {
                                            toast('Must add all product fields')
                                        }
                                        else {

                                            setProduct([...product, {
                                                name: prodDesc,
                                                quant: prodQuant,
                                                price: prodPrice
                                            }])


                                            setProdDesc('')
                                            setProdQuant('')
                                            setProdPrice('')
                                        }


                                    }}>
                                        Add
                                    </button>
                                </div>








                                <div
                                    className="table-responsive pb-5"
                                    style={{ overflow: "hidden", outline: "none" }}
                                    tabIndex={0}
                                >
                                    <table className="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th className="per70 text-center">Description</th>
                                                <th className="per5 text-center">Qty</th>
                                                <th className="per25 text-center">Total</th>
                                                <th className="per25 text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {product.map(i => {
                                                return (<>
                                                    <tr>
                                                        <td className='p-3' >
                                                            {i?.name}
                                                        </td>
                                                        <td className="text-center p-3">{i?.quant}</td>
                                                        <td className="text-center p-3" style={{ padding: '1.5rem' }}>${i?.price} USD</td>
                                                        <td className="text-center p-3">
                                                            <div
                                                                onClick={() => { setProduct(product?.filter(item => item !== i)) }}
                                                                className="btn btn-danger"
                                                            >
                                                                Delete{" "}
                                                            </div>
                                                        </td>
                                                    </tr>

                                                </>)
                                            })}

                                        </tbody>

                                    </table>
                                </div> */}



                                <div className="mb-2 mt-2" style={{ float: "inline-end" }}>
                                    <button type="submit" className="btn btn-theme" onClick={submit}>
                                        Update Quotation
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EditQuotation